export const CONTACT_MODES = {
    BULK: 'bulk',
    SINGLE: 'single',
};
